<template>
  <div>
    <v-select
      v-model="parentModel"
      variant="outlined"
      multiple
      density="compact"
      persistentPlaceholder
      hideDetails
      :items="parentItems"
      itemTitle="text"
      itemValue="value"
      :disabled="disabled"
      placeholder="Select "
      class="segment-builder--subtypes _subtypes"
      height="32px"
      bgColor="#ffffff"
      style="min-width: 180px"
      :menuProps="{ maxHeight: 410, offsetY: true }"
      @update:modelValue="emit('update:model', { channels: [...parentModel] })"
    />
  </div>
</template>

<script setup>
import { PushChannels } from "@/utils/constants/SegmentsConstants";
import { onMounted, ref } from "vue";

const emit = defineEmits(["update:model"]);
const props = defineProps(["filter", "disabled"]);
const parentModel = ref([]);
const parentItems = Object.values(PushChannels);

const prepareFilter = () => {
  const { channels } = props.filter;
  if (Array.isArray(channels)) parentModel.value = channels;
};

onMounted(prepareFilter);
</script>
